import { IDeal } from 'src/services/deal-flow/deal-flow.types';
import { Contact } from 'src/services/contacts/contacts.types';
import { ICompanyProfile } from 'src/services/connections/connections.types';

import { IJob } from 'src/services/jobs/jobs.types';
import { JobApplication } from 'src/services/applications/applications.types';
import { IThread } from '../threads/threads.types';
import { User } from '../organisation/organisation.types';

export enum TaskStatus {
  PENDING = 'pending',
  COMPLETED = 'completed'
}

export enum TaskPriority {
  NONE = 'none',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high'
}

export enum TaskType {
  GENERAL = 'general',
  TO_DO = 'to_do',
  CALL = 'call',
  EMAIL = 'email'
}

export enum DueMarker {
  ALL = 'all',
  UPCOMING = 'upcoming',
  OVERDUE = 'overdue',
  DUE_TODAY = 'due_today',
  COMPLETED = 'completed'
}

export interface ITask {
  id: string;
  title: string;
  description: string;
  status: TaskStatus;
  priority: TaskPriority;
  type: TaskType;
  due_at: Date | null;
  completed_at?: Date;
  created_at: string;
  updated_at: string;
  assigned_to: Partial<User>;
  created_by: Partial<User>;
  thread: IThread;
  contact: Contact;
  company_profile: ICompanyProfile;
  deal: IDeal;
  job?: IJob;
  job_application?: JobApplication;
}

export interface CreateTaskDto {
  title: string;
  description?: string;
  priority: TaskPriority;
  type: TaskType;
  due_at?: Date;
  assigned_to?: string;
  company_profile_id?: string | null;
  contact_id?: string | null;
  deal_id?: string | null;
  job_id?: string | null;
  job_application_id?: string | null;
}

export interface UpdateTaskDto {
  title?: string;
  description?: string;
  priority?: TaskPriority;
  type?: TaskType;
  due_at?: Date;
  assigned_to?: string;
  company_profile_id?: string | null;
  contact_id?: string | null;
  deal_id?: string | null;
  job_id?: string | null;
  job_application_id?: string | null;
}